import { useEffect } from 'react';

export const useRemoveItems = (callback: (newItems: any[]) => void, items: any[]) => {
  useEffect(() => {
    if (items.length > 3) {
      const firstStone = items[0]?.ref.current;

      if (firstStone) {
        const left = firstStone.getBoundingClientRect().left;

        if (left < -100) {
          const newStones = [...items];
          newStones.splice(0, 1);
          callback(newStones);
        }
      }
    }
  }, [callback, items]);
}
